import { useMemo } from 'react'
import type { BuildingMetrics } from '../OverviewTab.types'

export const useBuildingMetrics = (building: any): BuildingMetrics => {
  return useMemo(
    () => ({
      footprintArea: building.area || building.building_area || 0,
      height:
        building.building_height ||
        building.height ||
        building.height_estimate ||
        0,
      floorCount: building.floor_nb || 0,
      grossFloorArea: building.gross_floor_area || 0,
    }),
    [
      building.area,
      building.building_area,
      building.building_height,
      building.height,
      building.height_estimate,
      building.floor_nb,
      building.gross_floor_area,
    ]
  )
}
